module.exports = __webpack_public_path__ + "static/media/settings.0c32e837.png";